export default __webpack_public_path__ + "static/hep_beraber_biriktirin-1b603f26f8e8a87025bda35762f9ddfd.svg";